import PropTypes from 'prop-types';
import styled from 'styled-components';

import { guestAgreement, hostAgreement, privacyPolicy, termsOfUse } from '../helpers';
import { colors } from '../styles';

// Billing B4.4: the tick box for the terms. Sign-up (email, Google, Facebook)
// and the booking box. Copy approved by Braeden, 2026-10-31.

export const TERMS_ERROR = 'Tick the box to agree to the terms.';

const DOCUMENTS = {
  terms: { href: termsOfUse, label: 'Terms of Service' },
  guestTerms: { href: guestAgreement, label: 'Guest Terms' },
  hostTerms: { href: hostAgreement, label: 'Host Terms' },
  privacy: { href: privacyPolicy, label: 'Privacy Policy' }
};

// Sign-up: every document. Booking: the ones a booker agrees to.
export const SIGN_UP_DOCUMENTS = ['terms', 'guestTerms', 'hostTerms', 'privacy'];
export const BOOKING_DOCUMENTS = ['terms', 'guestTerms', 'privacy'];

const Box = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 0 0 16px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${colors.defaultText};
  cursor: pointer;

  input {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    margin: 1px 0 0;
    accent-color: ${colors.primaryButton};
    cursor: pointer;
  }

  a {
    color: ${colors.defaultText};
    text-decoration: underline;
  }
`;

const Error = styled.div`
  font-size: 12px;
  color: red;
  margin: -8px 0 16px 30px;
`;

/** "A, B, C and D" with each name a link to its document (new tab). */
function Links({ documents }) {
  return documents.map((key, i) => {
    const { href, label } = DOCUMENTS[key];
    const glue = i === 0 ? '' : i === documents.length - 1 ? ' and ' : ', ';
    return (
      <span key={key}>
        {glue}
        <a href={href} target="_blank" rel="noopener noreferrer">
          {label}
        </a>
      </span>
    );
  });
}

export default function TermsCheckbox({ id, checked, onChange, documents, error }) {
  return (
    <>
      <Box htmlFor={id}>
        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          aria-invalid={!!error}
          aria-describedby={error ? `${id}-error` : undefined}
        />
        <span>
          I agree to Yedding's <Links documents={documents} />.
        </span>
      </Box>
      {!!error && (
        <Error id={`${id}-error`} role="alert">
          {error}
        </Error>
      )}
    </>
  );
}

TermsCheckbox.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  documents: PropTypes.arrayOf(PropTypes.oneOf(Object.keys(DOCUMENTS))).isRequired,
  error: PropTypes.string
};
